'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'fan';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f863';
var svgPathData = ['M0 208c0 79.5 64.5 144 144 144 16.8 0 33-2.9 48-8.2L192 496c0 8.8 7.2 16 16 16 79.5 0 144-64.5 144-144 0-16.8-2.9-33-8.2-48L496 320c8.8 0 16-7.2 16-16 0-79.5-64.5-144-144-144-16.8 0-33 2.9-48 8.2L320 16c0-8.8-7.2-16-16-16-79.5 0-144 64.5-144 144 0 16.8 2.9 33 8.2 48L16 192c-8.8 0-16 7.2-16 16zm288 48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFan = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;